export default {"src":"https://search.testwiggot.com/_next/static/media/monopolio-logo-small.02388ac2.svg","height":13,"width":72,"blurWidth":0,"blurHeight":0};